const API_BASE = 'https://mosquepay.org/insurance_api/v1/api/'

module.exports = { API_BASE }
